/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Image, Text, View } from "@aws-amplify/ui-react";
export default function CtaMobile(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="507px"
      height="935px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "CtaMobile")}
      {...rest}
    >
      <Image
        width="1859px"
        height="935px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0px"
        left="-799px"
        padding="0px 0px 0px 0px"
        objectFit="unset"
        {...getOverrideProps(overrides, "AdobeStock_272999282_Preview")}
      ></Image>
      <Flex
        gap="32px"
        direction="column"
        width="306px"
        height="441px"
        justifyContent="center"
        alignItems="flex-start"
        position="absolute"
        top="400px"
        left="78px"
        padding="64px 20px 64px 20px"
        backgroundColor="rgba(34,66,114,1)"
        {...getOverrideProps(overrides, "Frame 1160464095")}
      >
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464096")}
        >
          <Text
            fontFamily="Inter"
            fontSize="32px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="40.959999084472656px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="266px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Your life won’t change if you just get a job. Your life changes when you get the perfect job!"
            {...getOverrideProps(
              overrides,
              "Your life won\u2019t change if you just get a job. Your life changes when you get the perfect job!"
            )}
          ></Text>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          borderRadius="8px"
          padding="12px 32px 12px 32px"
          backgroundColor="rgba(203,163,58,1)"
          {...getOverrideProps(overrides, "ButtonTesting")}
        >
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="24px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Change the Conversation"
            {...getOverrideProps(overrides, "label")}
          ></Text>
        </Flex>
      </Flex>
    </View>
  );
}
